import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { TranslatorContext } from "../../../context/Translator";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { FiArrowLeft, FiShoppingCart } from "react-icons/fi";
import { set, setDate } from "date-fns";

/**
 * TEMPORARY (until a real backend exists): reads the same localStorage
 * key that Purchase Entry writes to on Final Submit. No separate sale
 * tracking exists yet, so `sale` stays null unless the item's `status`
 * is "sold" and a `sale` object was attached to it elsewhere.
 */
// const STOCK_STORAGE_KEY = "dummy_stock_items";

// function readStockItemFromStorage(itemId) {
//   try {
//     const items = JSON.parse(localStorage.getItem(STOCK_STORAGE_KEY) || "[]");
//     return items.find((i) => String(i.id) === String(itemId)) || null;
//   } catch {
//     return null;
//   }
// }

/**
 * Stock Show — single item detail
 * Each stock row is one physical piece created from a Purchase Entry
 * child row, so this page shows that item's purchase details (weight,
 * stone, labour, vendor) plus its sale info if it has been sold.
 */
export default function StockShow() {
  const { t } = useContext(TranslatorContext);
  const { itemId } = useParams();
  const navigate = useNavigate();

  const [item, setItem] = useState(null);
  const [sale, setSale] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchItem();
  }, [itemId]);
  //API FOR GET ITEM OF STOCK
  const fetchItem = async () => {
    
    try {
      setLoading(true);


    const token = localStorage.getItem("authToken");
    
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/stock/{itemId}`,
      {
        headers:{
          Authorization:`bearer{token}`
        }
      }
    )

    if(res.data.status)
    {
      setDate(res.data.item);
      setSale(res.data.sale);
    }
    else{
      setDate(null);
      setSale(null);
    }
    } catch (error) {
      console.error(error);
    }finally
    {
      setLoading(false)
    }

    // --- LOCALSTORAGE DATA (remove once backend /stock/:itemId endpoint is ready) ---
    // setTimeout(() => {
    //   const record = readStockItemFromStorage(itemId);
    //   setItem(record || null);
    //   setSale(record?.sale || null);
    //   setLoading(false);
    // }, 200);
    // return;

    // --- REAL API CALL (uncomment when backend is ready) ---
    // const token = localStorage.getItem("authToken");
    // try {
    //     const response = await axios.get(`${process.env.REACT_APP_API_URL}/stock/${itemId}`, {
    //         headers: {
    //             Authorization: `Bearer ${token}`
    //         }
    //     });
    //     if (response.data.status) {
    //         setItem(response.data.item || null);
    //         setSale(response.data.sale || null);
    //     }
    // } catch (error) {
    //     console.error("Error fetching stock item:", error);
    // } finally {
    //     setLoading(false);
    // }
  };

  if (loading) {
    return (
      <PageLayout>
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 text-muted">{t("loading item...")}</p>
        </div>
      </PageLayout>
    );
  }

  if (!item) {
    return (
      <PageLayout>
        <div className="mc-card text-center py-5">
          <FiShoppingCart size={48} className="text-muted mb-2" />
          <p className="text-muted mb-3">{t("item not found")}</p>
          <button
            className="btn btn-secondary"
            onClick={() => navigate("/stock")}
          >
            <FiArrowLeft size={16} className="me-1" /> {t("Back to Stock")}
          </button>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb p-3">
              <h3 className="mc-breadcrumb-title mb-0">
                {item.parent_product_name}
                {item.child_product_name ? ` - ${item.child_product_name}` : ""}
              </h3>
              <ul className="mc-breadcrumb-list mb-0">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {t("home")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="/stock" className="mc-breadcrumb-link">
                    {t("stock management")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{t("item detail")}</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <button
            className="btn btn-secondary d-inline-flex align-items-center gap-2"
            onClick={() => navigate("/stock")}
          >
            <FiArrowLeft size={16} />
            {t("Back to Stock")}
          </button>
        </Col>
      </Row>

      <Row>
        <Col xl={4}>
          <div className="mc-card p-3 text-center">
            {item.image ? (
              <img
                src={item.image}
                alt={item.child_product_name || item.parent_product_name}
                style={{
                  width: "100%",
                  maxWidth: 260,
                  borderRadius: 8,
                  objectFit: "cover",
                }}
              />
            ) : (
              <div
                className="d-flex align-items-center justify-content-center bg-light text-muted mx-auto"
                style={{ width: 200, height: 200, borderRadius: 8 }}
              >
                {t("no image")}
              </div>
            )}
            <div className="mt-3">
              {item.status === "sold" ? (
                <span className="badge bg-secondary px-3 py-2">
                  {t("sold")}
                </span>
              ) : (
                <span className="badge bg-success px-3 py-2">
                  {t("in stock")}
                </span>
              )}
            </div>
          </div>
        </Col>

        <Col xl={8}>
          <div className="mc-card p-3 mb-3">
            <h5 className="mb-3">{t("Purchase Details")}</h5>
            <Row className="g-3">
              <Col md={6}>
                <strong>{t("Vendor")}:</strong> {item.vendor_name || "-"}
              </Col>
              <Col md={6}>
                <strong>{t("Invoice No.")}:</strong> {item.invoice_no || "-"}
              </Col>
              <Col md={6}>
                <strong>{t("Purchase Date")}:</strong>{" "}
                {item.purchase_date
                  ? new Date(item.purchase_date).toLocaleDateString()
                  : "-"}
              </Col>
              <Col md={6}>
                <strong>{t("Qty (batch size)")}:</strong> {item.qty || 1}
              </Col>
              <Col md={6}>
                <strong>{t("Gross Wt.")}:</strong>{" "}
                {Number(item.gross_weight || 0).toFixed(3)}g
              </Col>
              <Col md={6}>
                <strong>{t("Stone Wt.")}:</strong>{" "}
                {Number(item.stone_weight || 0).toFixed(3)}g
              </Col>
              <Col md={6}>
                <strong>{t("Net Wt.")}:</strong>{" "}
                {Number(item.net_weight || 0).toFixed(3)}g
              </Col>
              <Col md={6}>
                <strong>{t("Kaat (Ratti)")}:</strong> {item.kaat || "-"}
              </Col>
              <Col md={6}>
                <strong>{t("Pure Wt.")}:</strong>{" "}
                {Number(item.pure_weight || 0).toFixed(3)}g
              </Col>
              {item.stone_type && (
                <>
                  <Col md={6}>
                    <strong>{t("Stone Type")}:</strong> {item.stone_type}
                  </Col>
                  <Col md={6}>
                    <strong>{t("Stone Charges")}:</strong>{" "}
                    {item.stone_charges || 0} ({item.stone_charges_type || "-"})
                  </Col>
                </>
              )}
              <Col md={6}>
                <strong>{t("Labour")}:</strong> {item.labour || 0}
              </Col>
            </Row>
          </div>

          <div className="mc-card p-3">
            <h5 className="mb-3">{t("Sale Details")}</h5>
            {sale ? (
              <Row className="g-3">
                <Col md={6}>
                  <strong>{t("Sale Number")}:</strong> {sale.sale_number}
                </Col>
                <Col md={6}>
                  <strong>{t("Sale Date")}:</strong>{" "}
                  {sale.sale_date
                    ? new Date(sale.sale_date).toLocaleDateString()
                    : "-"}
                </Col>
                <Col md={6}>
                  <strong>{t("Customer")}:</strong> {sale.customer_name || "-"}
                </Col>
                <Col md={6}>
                  <strong>{t("Total Amount")}:</strong>{" "}
                  {Number(sale.total_amount || 0)}
                </Col>
              </Row>
            ) : (
              <p className="text-muted mb-0">
                {t("This item has not been sold yet.")}
              </p>
            )}
          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}
